export default function PHP___construct() {
  return (
    <div>
      <h1>PHP___construct</h1>
    </div>
  );
}
